/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import {
  UsersListComp,
  Header,
  UsersItemListComp,
  AnalyticsWidgetComp,
} from '../components';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import { useTheme } from '../../../providers/theme';
import {
  useSMUsersListPageGetContent,
  useSMNotifyUserUser,
  useSMCredentialsListPageGetContent,
} from '../machines';
import { Paginate } from '@vlinder-web/paginate-widget-react';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { vappContainer, VApplication } from '../../../application';
import { SettingsComp } from '../components/Settings';
import toast from 'react-hot-toast';
import { SearchFilter } from '../../../widgets/filter-widget-react';
import { CredentialListPageService } from '../services';
import { Modal } from 'react-bootstrap';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { Loader } from '@/components';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { AppNavigatorService } from '@/AppNavigator';
import { USER_LEVEL } from '@/config/userManagement.config';
import { useNavigate } from 'react-router-dom';

const getSrv = () => {
  return vappContainer.get<CredentialListPageService>(
    CredentialListPageService.displayName
  );
};
const getAppSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};
export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const [refreshPagination, setReFreshPagination] = useState(new Date());
  const staticPageContentConfig = getSrv()?.agent?.getStaticPageContentSync({});
  const storageService = StorageModule.getInstance();
  const appSrv = getAppSrv();

  const setApplicationsForPayment = (data: any[]) => {
    storageService.set('payableApplications', data, 'session');
    props?.onPaymentClick && props?.onPaymentClick();
  };

  const srv = getSrv();
  const navigate = useNavigate();
  const [filter,setFilter] = useState<any>(null);
  const { usersListPageSend, usersListPageState, usersListPageMachine } =
    useSMUsersListPageGetContent({});
  const [whoAmI, setWhoAmI] = useState('');
  console.log('usersListPageState->', usersListPageState);
  const { notifyUserUserSend, notifyUserUserState } = useSMNotifyUserUser({});
  const {
    CredentialsListPageMachine,
    CredentialsListPageSend,
    CredentialsListPageState,
  } = useSMCredentialsListPageGetContent({});
  const _onHeaderDDActionItemClick = (id: string) => {};

  const onError = () => {
    //window.location.reload(false);
    CredentialsListPageSend('TRIGGER_REFRESH', {});
  };
  console.log();
  const onRefresh = () => {
    CredentialsListPageSend('TRIGGER_REFRESH', {});
    setReFreshPagination(new Date());
  };

  const onClearFilter = () => {
    Array.from(document.querySelectorAll('input')).forEach(
      (input) => (input.value = '')
    );
    setFilter([]);
    CredentialsListPageSend('TRIGGER_REFRESH', {});
  };

  const onApplyFilter = (data: any, status: any) => {
    let criteria: any = [];
    if (data?.credentialNo) {
      criteria = [
        {
          column: 'credentialNo',
          op: 'Equal',
          value: data?.credentialNo,
        },
      ];
    }

    if (status) {
      criteria = [
        ...criteria,
        {
          column: 'type',
          op: 'Equal',
          value: status,
        },
      ];
    }
    setFilter(criteria)
    CredentialsListPageSend('TRIGGER_REFRESH', {
      where: criteria,
    });
  };

  const getWhoamI = async () => {
    const { whoami } = await appSrv.whoAmI();
    setWhoAmI(whoami);
  };

  useEffect(() => {
    getWhoamI();
  }, []);

  const onView = (id: string, type: string) => {
    console.log('id-type', id, type);
    navigate(`/applications?credential=${id}`, {
      state: { from: 'credential' },
    });
    // if (type === 'WORK_PERMIT' || type==='RIGHTS_OF_ESTABLISHMENT') {
    //   navigate(`/applications?wp=${id}`, {
    //     state: { from:'credential' },
    //   });
    // } else {
    //   navigate(`/applications?certificate=${id}`, {
    //     state: { from:'credential' },
    //   });
    // }
  };
  useEffect(() => {
    console.log('sadfasfdasdfasdf',CredentialsListPageState?.value);
  },[CredentialsListPageState?.value]);
  const onTogglePress = (key: string, id: string) => {
    console.log(`on toggle press ::`, key, id);
    if (key === 'notify') {
      notifyUserUserSend('START', {
        payload: {
          applicationID: id,
        },
      });
    }
    if (key === 'renew') {
      props?.onViewClick && props?.onViewClick(id);
    }
  };

  const _renderPage = () => {
    console.log(
      'usersListPageState?.event?.data?.value1',
      usersListPageState,CredentialsListPageState
    );

    if (
      usersListPageState?.matches('GET_PAGE_CONTENT') ||
      usersListPageState?.matches('GET_TOTAL_COUNT')
    ) {
      return (
        <Loader {...(staticPageContentConfig?.loading?.loadingUsers || {})} />
      );
    }

    if (usersListPageState?.matches('RENDER_PAGE')) {
      return (
        <>
          
            <>
              <AnalyticsWidgetComp
                // onAppCardClick={(title?: any) => onApplyFilter(title)}
                hoverColor={'#E6E6FA'}
                backgroundColor={'#c294c3'}
                // backgroundTitle={_renderCountry()}
                // highest={MapCardState?.event?.data?.value?.highest}
                {...(usersListPageState?.event?.data?.value || {})}
              />
            </>
          
        </>
      );
    }}
    const _renderList = () =>{
      if (
        CredentialsListPageState?.matches('GET_PAGE_CONTENT')
      ) {
        return (
          <Loader {...(staticPageContentConfig?.loading?.loadingUsers || {})} />
        );
      }
    if (CredentialsListPageState?.matches('RENDER_PAGE')) {
      console.log('sadfasfdasdfasdf', CredentialsListPageState?.data?.value,usersListPageState?.context?.table);
      return (
        <>
        {CredentialsListPageState?.event?.data?.value.isEmpty ? (
            <StateOSD
              {...(staticPageContentConfig?.loading?.usersEmpty || {})}
            />
          ) : 
         
          <UsersListComp
            {...(CredentialsListPageState?.event?.data?.value || {})}
            onTogglePress={onTogglePress}
            onViewClick={onView}
            onRowClick={props?.onViewDetailClick}
          />}
        </>
      );
    }
  };
  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <>
          <Header
            {...(staticPageContentConfig?.header || {})}
            onHeaderDDActionItemClick={_onHeaderDDActionItemClick}
            onRefreshClick={onRefresh}
          />
          {/* <SearchFilter
            {...(staticPageContentConfig?.settings || {})}
            onFilterApply={onApplyFilter}
            onClearFilter={onClearFilter}
          /> */}
        </>
      );
    }
    return null;
  };

  const onPaginationChange = (event: any) => {
    CredentialsListPageSend('TRIGGER_REFRESH', {
      offset: event?.selected * 10,
      size: 10,
      where : filter?filter:[]
    });
  };

  const _renderPagination = () => {
    if (!CredentialsListPageState?.event?.data?.value?.isEmpty) {
      return (
        <Paginate
          {...(CredentialsListPageState?.event?.data?.value || {})}
          onPageChange={onPaginationChange}
          key={refreshPagination}
          totalItems={CredentialsListPageState?.event?.data?.value?.ultUsers?.length}
        />
      );
    }
  };
  const _renderSettings = () => {
    return (<>
     <SettingsComp
            {...(staticPageContentConfig?.settings || {})}
            onApplyFilter={onApplyFilter}
            onClearFilter={onClearFilter}
          />
    </>)
  }
  const _renderErrorModals = () => {
    if (usersListPageState?.matches('RENDER_PAGE_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.getUsers || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
  };

  return (
    <div>
      {_renderHeader()}
      {_renderPage()}
      {_renderSettings()}
      {_renderList()}
      {_renderPagination()}
      {_renderErrorModals()}
    </div>
  );
};
